import React from 'react';
import {UploadDataPoint} from "../_section/DataPointForm";

function DataForm({upload, inExtWindow, setMortgage}) {
    return (
        <>
            <UploadDataPoint setMortgage={setMortgage} name="documentDate" upload={upload} inExtWindow={inExtWindow}/>
            <UploadDataPoint setMortgage={setMortgage} name="gifterNames" upload={upload} inExtWindow={inExtWindow}/>

            <UploadDataPoint setMortgage={setMortgage} name="amount" upload={upload} inExtWindow={inExtWindow}/>
        </>
    );


}


export default DataForm;